import { processSteps } from '../../data/company';
import SectionHeading from '../ui/SectionHeading';
import ProcessStep from '../ui/ProcessStep';
import AnimatedSection from '../ui/AnimatedSection';

export default function ProcessTimeline() {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <AnimatedSection>
          <SectionHeading
            subtitle="Our Process"
            title="The Lifetime Creation Approach"
            description="A structured, transparent process ensures your project is delivered efficiently and to the highest standards."
          />
        </AnimatedSection>

        <div className="mt-12 max-w-2xl mx-auto">
          {processSteps.map((step, index) => (
            <AnimatedSection key={step.step} delay={index * 0.1}>
              <ProcessStep
                step={step.step}
                title={step.title}
                description={step.description}
                icon={step.icon}
                isLast={index === processSteps.length - 1}
              />
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
